import { Component, Input, ChangeDetectionStrategy, OnChanges } from "@angular/core";
import { RankingEntry, ContestantInfo, LadderLike } from "@play/api-typings";
import { LinkService } from "@play/common";
import { Store } from "@ngrx/store";
import { RootState, getUser, distinct, getContestants, entryAvailable } from "@play/state";
import { Observable } from "rxjs";
import { filter, map, switchMap } from "rxjs/operators";

@Component({
    selector: "challenge-contestant",
    templateUrl: "./challenge-contestant.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChallengeContestantComponent implements OnChanges {
    public userEntry: Observable<ContestantInfo[]>;
    public isLoggedIn: Observable<boolean>;

    @Input() public contestant: RankingEntry;

    @Input() public league: LadderLike;

    @Input() public description: string;

    constructor(private links: LinkService, protected store: Store<RootState>) {}

    public ngOnChanges(): void {
        const user = this.store.select(getUser).pipe(
            filter(usr => usr && Boolean(!usr.loading || usr.entry)),
            distinct(usr => usr)
        );

        this.isLoggedIn = user.pipe(map(usr => Boolean(usr.entry)));

        this.userEntry = user.pipe(
            filter(usr => Boolean(usr && usr.entry && usr.entry.id)),
            switchMap(usr =>
                this.store.select(getContestants(this.league.id, +usr.entry.id)).pipe(
                    filter(entryAvailable),
                    map(contestants => contestants.entry)
                )
            )
        );
    }

    public getContestantLink(contestant: RankingEntry) {
        if (contestant.user) {
            return this.links.player(+contestant.user.id, contestant.user.alias);
        }

        return this.links.teamContestant(this.league.uri, this.league.enabledFeatures.includes("roster"), +contestant.team.id);
    }
}
